class Common {
  _init = async () => {
    return true
  }

  setTvWindowSize = async () => {
    return true
  }
}

export default Common
